module.exports = __webpack_public_path__ + "assets/ea69ffbc42c1e3594005b4e2ce811a76.png";